import { useNavigate } from 'react-router-dom';
import { FlexStack } from '~/components/atomic';
import { HelmetHead } from '~/components/common';
import { Header } from '~/components/common/Header';
import { PAGE_ROUTE } from '~/constants';
import SignUpSuccessImage from '~/assets/img/dart/success_signin_dart.png';
import * as S from './index.styled';

export default function SignUpSuccess() {
  const navigate = useNavigate();

  return (
    <>
      <HelmetHead title='Success' />
      <Header.Root>
        <Header.Section>
          <Header.PrevButton />
        </Header.Section>
      </Header.Root>

      <S.Container>
        <S.SuccessWrapper>
          <FlexStack direction='column'>
            <S.Title>Welcome to Hey.D!</S.Title>
            <S.ImageBox>
              <img src={SignUpSuccessImage} alt='signup_success' />
            </S.ImageBox>
            <S.DescBox>
              <S.Desc>Start chatting with free Darts!</S.Desc>
              <S.SubDesc>
                <em>Today Only</em>
              </S.SubDesc>
            </S.DescBox>
          </FlexStack>
          <S.SignInSuccessButton
            onClick={() => navigate(PAGE_ROUTE.SIGNIN_HOME)}
          >
            Sign in
          </S.SignInSuccessButton>
        </S.SuccessWrapper>
      </S.Container>
    </>
  );
}
